module.exports = __webpack_public_path__ + "static/media/blink2.0281f1f1.png";